// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__340Am","cell":"ColumnAccessor_cell__3FlIL","firstCellAccent":"ColumnAccessor_firstCellAccent__13UHK"};